
import Vue from "vue";
import { Assessment } from "@/interfaces/recruiter/candidates/create_assessment";

export default Vue.extend({
  name: "EditAssessmentHeader",
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    isFormValid: {
      type: Boolean,
      default: true
    },
    assessment: {
      type: Object as () => Assessment,
      required: true
    }
  },
  computed: {
    isEditMode(): boolean {
      return Boolean(this.assessment?.id);
    }
  }
});
